// *******************************
// * THIS IS AUTO GENERATED FILE *
// *******************************

import * as Toolbox from '../../infrastructure/toolbox';

// TracksOffice.Models.Login.LoginContract
export interface LoginContract {
	userName: string;
	password: string;
}

// TracksOffice.Models.Login.LoginIndexResponse
export interface LoginIndexResponse_Server {
	YumLoginUrl: string;
	AppName: string;
	ClockEntryUrl: string;
	AppVersion: string;
	AppType: string;
	RedirectUrl: string;
	RedirectUserName: string;
	CacheSuffix: string;
	TracksStyle: string;
	TurnOnForgotPWD: boolean;
	WarningMessages: string[];
	IsBrowserRegistered: boolean;
	ForgotUserNameMessage: string;
	OnlySSOLoginAllowed: boolean;
	Messages: CorporateMessageResponse_Server[];
	UrlForNotAppropriateUser: string;
}
// TracksOffice.Models.Login.LoginIndexResponse
export interface LoginIndexResponse {
	yumLoginUrl: string;
	appName: string;
	clockEntryUrl: string;
	appVersion: string;
	appType: string;
	redirectUrl: string;
	redirectUserName: string;
	cacheSuffix: string;
	tracksStyle: string;
	turnOnForgotPWD: boolean;
	warningMessages: string[];
	isBrowserRegistered: boolean;
	forgotUserNameMessage: string;
	onlySSOLoginAllowed: boolean;
	messages: CorporateMessageResponse[];
	urlForNotAppropriateUser: string;
}
// TracksOffice.Models.Login.CorporateMessageResponse
export interface CorporateMessageResponse_Server {
	Subject: string;
	Body: string;
	CreatedDate: string;
}
// TracksOffice.Models.Login.CorporateMessageResponse
export interface CorporateMessageResponse {
	subject: string;
	body: string;
	createdDate: Date;
}
// TracksOffice.Models.Login.LoginResponse
export interface LoginResponse_Server {
	IsSuccess: boolean;
	IsMultipleSignIn: boolean;
	RedirectUrl: string;
	Fullname: string;
	Errors: string[];
	IsPwdExpiredDate: boolean;
	IsNeededToChangePWD?: boolean;
}
// TracksOffice.Models.Login.LoginResponse
export interface LoginResponse {
	isSuccess: boolean;
	isMultipleSignIn: boolean;
	redirectUrl: string;
	fullname: string;
	errors: string[];
	isPwdExpiredDate: boolean;
	isNeededToChangePWD?: boolean;
}

// Convert LoginIndexResponse_Contract > LoginIndexResponse_Response
export const map_LoginIndexResponse = (data: LoginIndexResponse_Server): LoginIndexResponse => {
	return {
		yumLoginUrl: data.YumLoginUrl,
		appName: data.AppName,
		clockEntryUrl: data.ClockEntryUrl,
		appVersion: data.AppVersion,
		appType: data.AppType,
		redirectUrl: data.RedirectUrl,
		redirectUserName: data.RedirectUserName,
		cacheSuffix: data.CacheSuffix,
		tracksStyle: data.TracksStyle,
		turnOnForgotPWD: data.TurnOnForgotPWD,
		warningMessages: data.WarningMessages || [],
		isBrowserRegistered: data.IsBrowserRegistered,
		forgotUserNameMessage: data.ForgotUserNameMessage,
		onlySSOLoginAllowed: data.OnlySSOLoginAllowed,
		messages: (data.Messages || []).map(item => map_CorporateMessageResponse(item)),
		urlForNotAppropriateUser: data.UrlForNotAppropriateUser,
	};
};
// Convert CorporateMessageResponse_Contract > CorporateMessageResponse_Response
export const map_CorporateMessageResponse = (data: CorporateMessageResponse_Server): CorporateMessageResponse => {
	return {
		subject: data.Subject,
		body: data.Body,
		createdDate: Toolbox.parseDate(data.CreatedDate),
	};
};
// Convert LoginResponse_Contract > LoginResponse_Response
export const map_LoginResponse = (data: LoginResponse_Server): LoginResponse => {
	return {
		isSuccess: data.IsSuccess,
		isMultipleSignIn: data.IsMultipleSignIn,
		redirectUrl: data.RedirectUrl,
		fullname: data.Fullname,
		errors: data.Errors || [],
		isPwdExpiredDate: data.IsPwdExpiredDate,
		isNeededToChangePWD: data.IsNeededToChangePWD,
	};
};
